// HttpClient and RestResponse is duplicated in all clients api code
import pickBy from 'lodash/pickBy';

import { HttpClient as HttpClientInterface, RestResponse } from '@ndvr/customer-api';

import { fetcher } from './fetcher';

const buildApiUrl = (rootUrl: string, url: string, queryParams: URLSearchParams) => {
    const query = queryParams.toString();
    return `${rootUrl}/${url}${query ? `?${query}` : ''}`;
};

export class HttpClient implements HttpClientInterface {
    private readonly rootUrl: string;
    private readonly hideError: boolean;

    /**
     * @param rootUrl - rootUrl of the service
     * @param hideError - false to show notification (Toast) to the users on error
     */
    constructor(rootUrl: string, hideError = false) {
        this.rootUrl = rootUrl;
        this.hideError = hideError;
    }

    async request<R>(requestConfig: {
        method: 'GET' | 'POST' | 'PUT' | 'DELETE';
        url: string;
        queryParams?: { [key: string]: string | undefined };
        data?: any;
        copyFn?: (data: R) => R;
    }): RestResponse<R> {
        const fileToUpload = requestConfig.queryParams?.['fileToUpload'];
        const queryParams = fileToUpload
            ? Object.fromEntries(
                  Object.entries(requestConfig.queryParams ?? {}).filter(([key]) => key !== 'fileToUpload'),
              )
            : requestConfig.queryParams;

        // undefined as value should not happen as the type is protected, but this is still JS
        const cleanedParams = pickBy(queryParams, (v): v is string => v !== undefined);
        const apiUrl = buildApiUrl(this.rootUrl, requestConfig.url, new URLSearchParams(cleanedParams));

        const headers: { [key: string]: string } = {};

        let data;
        if (requestConfig.method === 'POST' && fileToUpload) {
            data = new FormData();
            data.append('fileToUpload', fileToUpload);
        } else if (requestConfig.data) {
            headers['Content-Type'] = 'application/json';
            data = typeof requestConfig.data === 'object' ? JSON.stringify(requestConfig.data) : requestConfig.data;
        }

        return await fetcher<R>(
            apiUrl,
            {
                method: requestConfig.method,
                body: data,
                headers,
            },
            this.hideError,
        );
    }
}
